import { Component, ChangeDetectorRef, ElementRef } from '@angular/core';
import { DialogBase, M27Dialog, DialogButton } from '@m27/common';
import { XmlService } from '@reporting/services';
import { IReportHistory, ReportType, IVolunteerReportExportRequest } from '@reporting/interfaces';
import { IXmlExportResult } from '@reporting/interfaces/exports';
import { IVolunteerXmlExportResult } from '@reporting/interfaces/exports/volunteer-xml-export-result';
import { IFinalFieldTestXmlExportResult } from '@reporting/interfaces/exports/final-field-test-xml-export-result';
import { IFinalFieldTestReportExportRequest } from '@reporting/interfaces/final-field-test-report';

@Component({
    selector: 'reporting-dialog-volunteer-report-xml-result',
    templateUrl: './dialog-volunteer-report-xml-result.component.html',
    styleUrls: ['./dialog-volunteer-report-xml-result.component.scss']
})
export class VolunteerReportXmlResultDialogComponent extends DialogBase implements M27Dialog {

    public loading: boolean = true;
    public xmlResult: IXmlExportResult = null;
    public processComplete: boolean = false;

    constructor(private xmlService: XmlService, cd: ChangeDetectorRef, elRef: ElementRef) {
        super(cd, elRef);
    }

    public init(): void {
        this.xmlResult = null;
        this.processComplete = false;
    }

    public onDialogReady(): void {
    }

    private setupButtons(): void {
        this.rightButtons.push(new DialogButton(<DialogButton>{
            IsCancel: false,
            IsDisabled: () => !this.processComplete,
            Text: 'Close',
            IsPrimary: () => true,
            Action: (dialogBase: DialogBase) => {
                this.close();
            }
        }));
    }

    public open(reportId: number, reportType: ReportType, isReportFinal: boolean, isEfile: boolean) {
        this.init();

        this.onOpen.emit(false);
        this.modal.open();
        this.setupButtons();
        this.loading = true;
        if (reportType === ReportType.Volunteer) {
            const exportVolunteerRequest: IVolunteerReportExportRequest = {
                ReportId: reportId,
                IsReportFinal: isReportFinal,
                isEfile: isEfile
            };
            this.exportVolunteerReport(exportVolunteerRequest);
        }
        if (reportType === ReportType.FinalFieldTest) {
            const exportFinalFieldRequest: IFinalFieldTestReportExportRequest = {
                ReportId: reportId,
                IsReportFinal: isReportFinal,
                isEfile: isEfile
            };
            this.exportFinalFieldTestReport(exportFinalFieldRequest);
        }
    }

    private exportVolunteerReport(request: IVolunteerReportExportRequest) {
        this.xmlService.ExportToXmlVolunteerReport(request)
            .subscribe((data: IVolunteerXmlExportResult) => {
                this.xmlResult = data;
                this.processComplete = true;
            });
    }

    private exportFinalFieldTestReport(request: IFinalFieldTestReportExportRequest) {
        this.xmlService.ExportToXmlFinalFieldTestReport(request)
            .subscribe((data: IFinalFieldTestXmlExportResult) => {
                this.xmlResult = data;
                this.processComplete = true;
            });
    }

    private dataIsReady(results: IReportHistory[]): boolean {
        this.loading = false;
        this.processComplete = true;
        return true;
    }

    onDestroy() {
        this.clearButtons();
    }

    canCancel(): boolean {
        return true;
    }
}
